// extracted by mini-css-extract-plugin
export default {"root":"NoOffRampsYet_root__SNRFp","content":"NoOffRampsYet_content__5eGxG","message":"NoOffRampsYet_message__Xulr-","buttonWrapper":"NoOffRampsYet_buttonWrapper__DhHe8"};